import Close from "@mui/icons-material/Close";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { tk } from "@thalamos/vision-common";

import { Banner } from "../../components/Banner/Banner.js";
import { PopupDialog } from "../../components/Dialog/PopupDialog.js";

export interface FormRejectedModalProps {
  open: boolean;
  reason: string;
  close: () => void;
  onClose: () => void;
  onShare: () => void;
  userName: string;
  userEmail: string;
}
export function FormRejectedModal({
  open,
  reason,
  close,
  onClose,
  onShare,
  userName,
  userEmail,
}: FormRejectedModalProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <PopupDialog
      open={open}
      onClose={close}
      maxWidth="sm"
      fullWidth
      fullScreen={fullScreen}
      disableDialogRootPadding={true}
    >
      <DialogTitle sx={{ fontSize: "1.250rem", fontWeight: "bold" }}>
        {t("s136FormRejectedNotification.formDeclined")}
        <IconButton
          aria-label="close"
          onClick={close}
          edge="end"
          sx={{
            position: "absolute",
            right: 15,
            top: 8,
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{ color: "primary", fontSize: "0.875rem" }}
          gutterBottom
        >
          {t("s136FormRejectedNotification.formRjectedBy")}
        </Typography>
        <Typography
          sx={{ color: "primary", fontSize: "0.875rem", fontWeight: "bold" }}
          gutterBottom
        >
          {userName} ({userEmail})
        </Typography>
        <Typography
          sx={{ color: "primary", fontSize: "0.875rem" }}
          gutterBottom
        >
          {t("s136FormRejectedNotification.reason")}
        </Typography>
        <Typography
          sx={{ color: "primary", fontSize: "0.875rem" }}
          gutterBottom
        >
          {reason}
        </Typography>
        <Box sx={{ marginTop: "2rem" }}>
          <Banner
            body={tk("s136FormRejectedNotification.reshareForm")}
            bannerType={"warning"}
          />
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          px: 3,
        }}
      >
        <Button
          onClick={() => {
            onClose();
          }}
          color="error"
          variant="outlined"
        >
          {t("common.close")}
        </Button>
        <Button onClick={onShare} color="primary" variant="contained">
          {t("s136FormRejectedNotification.reshare")}
        </Button>
      </DialogActions>
    </PopupDialog>
  );
}
